import React from 'react';
import { useAorText } from 'utils/aorTerminology';
import FormTextField from '../../../components/IAP/formFields/FormTextField';
import FormSelectField from '../../../components/IAP/formFields/FormSelectField';
import { IncidentTypes } from '../../../components/IncidentConfig/IncidentTypes';
import { getRefreshCadenceOptions } from '../utils/cronUtils';
import { useAors } from '../../../hooks/useAors';

const BasicInformationStep: React.FC = () => {
  const aorText = useAorText();
  const { data: allAor } = useAors();

  return (
    <div className="d-flex flex-column gap-3">
      <FormTextField
        title="Configuration Name"
        fieldName="name"
        rules={{ required: 'Name is required' }}
      />

      <FormSelectField
        title="Event Type"
        fieldName="eventType"
        options={IncidentTypes.map((type) => ({
          value: type,
          label: type,
        }))}
        rules={{ required: { value: true, message: 'Event type is required' } }}
      />

      <FormSelectField
        title={aorText('AOR (Area of Responsibility)')}
        fieldName="aorId"
        options={allAor?.map((aor) => ({
          value: aor.id,
          label: aor.name,
        }))}
        rules={{
          required: { value: true, message: aorText('AOR is required') },
        }}
      />

      <FormSelectField
        title="Refresh Cadence"
        fieldName="refreshCadence"
        options={getRefreshCadenceOptions()}
        rules={{
          required: { value: true, message: 'Refresh cadence is required' },
        }}
      />
    </div>
  );
};

export default BasicInformationStep;
